import React, { useEffect } from "react";
import { Alert, Col, Container, Row } from "reactstrap";

import Header from "./Header";
import MainDetails from "./MainDetails";
import AdditionalDetails from "./AdditionalDetails";
import { useParams, useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { getEUSanctionedItem as onGetEUSanctionedItem } from "slices/thunks";
import BreadCrumb from "Components/Common/BreadCrumb";

const ViewEUSanctionedItem = () => {
  const location = useLocation();
  const dispatch: any = useDispatch();

  const { id: itemId } = useParams();
  usePageActivity(location.pathname, "View EU Sanctions List", itemId);

  useEffect(() => {
    dispatch(onGetEUSanctionedItem(itemId));
  }, [itemId, dispatch]);

  const selectLayoutState = (state: any) => state.SanctionsList;
  const selectProperties = createSelector(selectLayoutState, (state) => ({
    euSanctionedItem: state.euSanctionedItem,
  }));

  const { euSanctionedItem } = useSelector(selectProperties);

  document.title = "EU Sanctioned Item | CIMS";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="EU Sanction Details"
            pageTitles={[
              {
                title: "Dashboard",
                link: "/",
              },
              { title: "EU Sanctions List", link: "/sanctions-list/eu" },
            ]}
            back
          />
          <Row>
            <Col>
              <Alert color="danger" className="material-shadow">
                <strong> EU Sanction! </strong> This entity has been sanctioned
                by the EU. Please check the profile below for more information.
              </Alert>
            </Col>
          </Row>

          <Row>
            <Header data={euSanctionedItem} />
          </Row>
          <Row>
            <MainDetails data={euSanctionedItem} />
            <AdditionalDetails data={euSanctionedItem} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewEUSanctionedItem;
